(function ($) {
	$.fn.naturataTabbedContent = function () {

		return $(this).each(function () {
			var container = $(this);
            var select = container.find('select');
            var tabRadios = container.find('input[type=radio]');

            select.on('change', function() {
                var selectedIndex = select.find(":selected").index();
				tabRadios.removeAttr('checked').prop("checked", false);
                $(tabRadios[selectedIndex]).attr('checked', true).prop("checked", true);
            });
		});
	};
	$(function () {
		$('[data-naturata-tabbed-content]').naturataTabbedContent();
	});
})(jQuery);
